{
  "name": "bo-app",
  "version": "2.8.7-63-omsorg-and-possibly-make-email-optional.5",
  "scripts": {
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "install": "cp ./package.json ./src/assets",
    "lint": "ng lint",
    "ng": "ng",
    "start": "ng serve --ssl --host localhost.sparbanken.me",
    "style-lint": "stylelint  \"src/**/*.scss\" --fix",
    "test": "ng test --watch=false --code-coverage",
    "watch": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.1.5",
    "@angular/cdk": "^21.1.5",
    "@angular/common": "^21.1.5",
    "@angular/compiler": "^21.1.5",
    "@angular/core": "^21.1.5",
    "@angular/forms": "^21.1.5",
    "@angular/material": "^21.1.5",
    "@angular/platform-browser": "^21.1.5",
    "@angular/platform-browser-dynamic": "^21.1.5",
    "@angular/router": "^21.1.5",
    "rxjs": "^7.8.1",
    "tslib": "^2.4.0",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^21.1.5",
    "@angular/cli": "^21.1.5",
    "@angular/compiler-cli": "^21.1.5",
    "@angular/material-luxon-adapter": "^21.1.5",
    "@sparbanken-syd/auth-backend": "^2.5.3",
    "@sparbanken-syd/borgo-helpers": "^21.0.0",
    "@sparbanken-syd/borgo-types": "^1.0.3",
    "@sparbanken-syd/personnummer": "^3.0.1",
    "@sparbanken-syd/sparbanken-syd-bankid": "^21.0.1",
    "@sparbanken-syd/sparbanken-syd-qr": "^21.0.0",
    "@sparbanken-syd/sparbanken-syd-theme": "^21.2.0",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^21.1.1",
    "@sparbanken-syd/spb-file-mgmt": "^1.3.0",
    "@types/jasmine": "^5.1.7",
    "@types/jmespath": "^0",
    "@types/karma-spec-reporter": "^0",
    "@types/luxon": "^3.4.2",
    "@types/node": "22",
    "@typescript-eslint/eslint-plugin": "^8.33.1",
    "@typescript-eslint/parser": "^8.33.1",
    "@typescript-eslint/types": "^8.26.1",
    "@typescript-eslint/utils": "^8.33.1",
    "angular-eslint": "^21.2.0",
    "eslint": "^9.28.0",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "jasmine-core": "^5.6.0",
    "jmespath": "^0.16.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "karma-spec-reporter": "^0.0.36",
    "luxon": "^3.5.0",
    "postcss": "^8.5.3",
    "postcss-scss": "^4.0.9",
    "puppeteer": "^24.37.5",
    "stylelint": "^16.15.0",
    "stylelint-config-standard-scss": "^16.0.0",
    "stylelint-scss": "^6.11.1",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.33.1"
  },
  "closed": {
    "start": "2025-04-09T03:00:00",
    "end": "2025-04-09T09:00:00"
  }
}
